<template>
  <div class="cps-main-page">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item
        ><i class="el-icon-s-home"></i>首页</el-breadcrumb-item
      >
      <el-breadcrumb-item>游戏管理</el-breadcrumb-item>
      <el-breadcrumb-item>游戏列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-divider></el-divider>
    <div class="page-content">
      <el-row @keyup.enter.native="loadData(1)">
        <el-input
          v-model="queryField.gameId"
          size="small"
          placeholder="游戏ID"
        ></el-input>
        <el-input
          v-model="queryField.gameName"
          size="small"
          placeholder="游戏名称"
        ></el-input>
        <el-select
          v-model="queryField.gameStatus"
          size="small"
          placeholder="游戏状态"
        >
          <el-option
            v-for="item in optionsGameStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="queryField.gameGrade"
          size="small"
          placeholder="游戏级别"
        >
          <el-option
            v-for="item in optionsGameGrade"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="queryField.gameTopic"
          size="small"
          placeholder="游戏类别"
        >
          <el-option
            v-for="item in optionsGameTopic"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="queryField.gameType"
          size="small"
          placeholder="游戏类型"
        >
          <el-option
            v-for="item in optionsGameType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="queryField.queryType"
          size="small"
          placeholder="查询类型"
        >
          <el-option label="全部" value="0"></el-option>
          <el-option label="未推广" value="1"></el-option>
          <el-option label="已推广" value="2"></el-option>
        </el-select>
        <el-autocomplete
          v-if="isSupper"
          class="inline-input"
          v-model="queryField.gameOf"
          :fetch-suggestions="querySearch"
          placeholder="游戏厂商"
          @select="handleSelect"
        ></el-autocomplete>
        <br>
        <br>
        <el-select v-model="queryField.showForum">
          <el-option label="展示论坛" value=""></el-option>
          <el-option label="是" value="1"></el-option>
          <el-option label="否" value="2"></el-option>
        </el-select>
        <el-select v-model="queryField.indexType">
          <el-option label="推荐类型" value="0"></el-option>
          <el-option label="热门游戏" value="1"></el-option>
        </el-select>
        <el-button
          v-if="showQuery"
          type="primary"
          icon="el-icon-search"
          size="small"
          @click="loadData(1)"
          >查询
        </el-button>
        <el-button type="primary" @click="moveSission" size="small"
          >重置
        </el-button>
        <el-button
          v-if="showAdd"
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="toAdd"
          >新增</el-button
        >
      </el-row>
      <el-table
        class="cps-table-data"
        :data="tableData"
        size="small"
        border
        :height="height"
        ref="tableRef"
        style="width: 100%"
      >
        <el-table-column :key="1" prop="game_id" label="游戏ID" width="60" fixed>
        </el-table-column>
        <el-table-column :key="2" prop="game_name" label="游戏名称" width="120" fixed>
        </el-table-column>
        <el-table-column :key="3" prop="game_status" label="游戏状态" width="80">
          <!--    采用span修改样式    原方法 :formatter="formatGameStatus"  -->
          <template slot-scope="scope">
            <span style="color: #e6a23c" v-if="scope.row.game_status === 1"
              >调试</span
            >
            <span style="color: #67c23a" v-if="scope.row.game_status === 2"
              >上线</span
            >
            <span style="color: #f56c6c" v-if="scope.row.game_status === 3"
              >下线</span
            >
          </template>
        </el-table-column>
        <el-table-column :key="4"
          v-if="isShowGameOf"
          prop="game_of"
          label="游戏厂商"
          width="80"
        >
        </el-table-column>
        <el-table-column :key="5"
          prop="game_level"
          label="游戏级别"
          :formatter="formatGameGrade"
          width="80"
        >
        </el-table-column>
        <el-table-column :key="6"
          prop="game_type"
          label="游戏类型"
          :formatter="formatGameType"
          width="80"
        >
        </el-table-column>
        <el-table-column :key="7"
            prop="game_system"
            label="游戏系统"
            width="80"
        >
          <template slot-scope="scope">
            <img v-if="!(scope.row.game_system === 2)" src="../../assets/android.png" style="width: 22px;height: 22px;margin-right:5px">
            <img v-if="!(scope.row.game_system === 1)" src="../../assets/apple.png" style="width: 22px;height: 22px">
          </template>
        </el-table-column>
        <el-table-column :key="8" prop="game_icon" label="游戏图标" width="80">
          <template slot-scope="scope">
            <el-image
              style="width: 30px; height: 30px; border-radius: 3px"
              :src="scope.row.game_icon"
              fit="cover"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column :key="9"
          label="游戏app下载地址"
          width="260"
        >
          <template slot-scope="scope">
            <a v-if="scope.row.url_show === 1" style="color: #409EFF" :href="scope.row.game_app_url">{{scope.row.game_app_url}}</a>
          </template>
        </el-table-column>
        <el-table-column :key="10" prop="game_url" label="游戏网页地址" width="240">
          <template slot-scope="scope">
            <a v-if="scope.row.url_show === 1" style="color: #409EFF" :href="scope.row.game_url">{{scope.row.game_url}}</a>
          </template>
        </el-table-column>
        <el-table-column prop="qrCode"
                         label="二维码"
                         width="60"
                         v-if="showQrCode">
            <template slot-scope="scope">
                <el-button type="text" size="small" @click="toCreateQrCode(scope.row.game_id)">生成</el-button>
            </template>
        </el-table-column>
        <el-table-column :key="11" label="自助折扣" width="110">
          <template slot-scope="scope">
            <el-input
              :disabled="!showAuto"
              class="cps-line-input"
              v-model="tableData[scope.$index].auto_share"
              size="small"
              placeholder="自助分成"
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column :key="12" label="初始提成" v-if="isSupper" prop="init_share" ></el-table-column>
        <el-table-column :key="13" label="首充提成"  prop="first_share" ></el-table-column>
        <el-table-column :key="14" label="续充提成"  prop="continue_share" ></el-table-column>
        <el-table-column :key="15" label="操作" width="350">
          <template slot-scope="scope">
            <el-button
              v-if="showEdit"
              type="text"
              size="small"
              @click="toEdit(scope.row.game_id)"
              >编辑</el-button
            >
            <el-button
              v-if="showPackage"
              type="text"
              size="small"
              @click="toUpload(scope.row)"
              >包管理</el-button
            >
            <el-button
              v-if="showDownload"
              type="text"
              size="small"
              @click="toUploadIMG(scope.row.game_id)"
              >logo上传
            </el-button>
            <el-button
              v-if="showAuto"
              type="text"
              size="small"
              @click="save(scope.row)"
              >保存</el-button
            >
            <el-button
              v-if="scope.row.game_type !== 3"
              type="text"
              size="small"
              @click="toPush(scope.row.game_id,scope.row.audit_flag)"
              >我要推广</el-button
            >
            <el-button
              v-if="showPackage"
              type="text"
              size="small"
              @click="forcePackage(scope.row.game_id)"
              >强制重分
            </el-button>
            <el-button
                v-if="showSubpackage"
                type="text"
                size="small"
                class="btn-gap"
                @click="doSubpackage(scope.row.game_id,scope.row.game_name)"
            >一键分包
            </el-button>
<!--            <el-button
                v-if="showRefresh"
                type="text"
                size="small"
                :class="{'btn-gap': !showSubpackage}"
                @click="refreshTask(scope.row.game_id)">
              刷新cdn
            </el-button>-->
            <el-button
                v-if="showRefresh"
                type="text"
                size="small"
                @click="cdnDialogVisible = true;refreshGameId = scope.row.game_id">
              刷新cdn
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="cps-table-data"
        @current-change="loadData"
        background
        :page-size="15"
        :current-page="currentIndex"
        layout="total, prev, pager, next"
        :total="total"
      >
      </el-pagination>

      <el-dialog
        title="app包管理"
        visible.sync="false"
        :center="true"
        width="400px"
        :show-close="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-upload
          class="avatar-uploader"
          action=""
          :data="param"
          :http-request="httpRequest"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">
            只能上传apk/ipa文件，且不超过5GB
          </div>
        </el-upload>
        <el-progress
          ref="appLoadProgress"
          :percentage="loadProgress"
        ></el-progress>
      </el-dialog>
      <el-dialog
          title="app包管理"
          :visible.sync="dialogFormVisible"
          :center="true"
          width="400px"
          :show-close="true"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
      >
        <el-upload
            class="avatar-uploader"
            action=""
            drag
            :data="param"
            :http-request="httpRequest2"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">
            只能上传apk/ipa文件，且不超过5GB
          </div>
        </el-upload>
        <el-progress
            ref="appLoadProgress"
            :percentage="loadProgress"
        ></el-progress>
      </el-dialog>
        <el-dialog
            title="包管理"
            :visible.sync="cpsDialogFormVisible"
            :center="false"
            width="500px"
            :show-close="true"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            custom-class="cps-upload-dialog">
            <el-form label-width="70px">
                <el-form-item label="渠道">
                    <el-select v-model="param.channel" size="small" placeholder="请选择渠道">
                        <el-option v-for="item in channelList" :key="item.admin_id" :label="item.nick_name" :value="item.admin_id"></el-option>
                    </el-select>
                    <div class="upload__tip">文件将上传到选择的渠道下</div>
                </el-form-item>
                <el-form-item label="上传文件">
                    <el-upload
                        ref="cps-upload"
                        action=""
                        :data="param"
                        :http-request="httpRequest2"
                        :show-file-list="true"
                        :before-upload="beforeAvatarUpload"
                        :auto-upload="false"
                        :multiple="false"
                        :limit="1"
                    >
                        <el-button slot="trigger" size="small">选取文件</el-button>
                        <div class="upload__tip" slot="tip">
                            只能上传apk/ipa文件，且不超过5GB
                        </div>
                    </el-upload>
                  <el-progress
                      ref="appLoadProgress"
                      v-if="showCpsProgress"
                      :percentage="loadProgress"
                  ></el-progress>
                </el-form-item>
            </el-form>
            <div slot="footer">
                <el-button size="small" @click="cancelCpsUpload">取消</el-button>
                <el-button size="small" type="primary" @click="submitCpsUpload">确认上传</el-button>
            </div>
        </el-dialog>
      <el-dialog
        title="logo上传"
        visible.sync="false"
        :center="true"
        width="400px"
        :show-close="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-upload
          class="avatar-uploader"
          action=""
          drag
          :data="param"
          :http-request="httpRequestIMG"
          :show-file-list="false"
          :on-success="handleAvatarSuccessIMG"
          :before-upload="beforeAvatarUploadIcon"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">
            只能上传png/jpg文件，且不超过2M
          </div>
        </el-upload>
        <el-progress
          ref="iconLoadProgress"
          :percentage="loadProgress"
        ></el-progress>
      </el-dialog>
      <el-dialog
          title="logo上传"
          :visible.sync="dialogFormVisible1"
          :center="true"
          width="400px"
          :show-close="true"
          :close-on-click-modal="false"
          :close-on-press-escape="false"
      >
        <el-upload
            class="avatar-uploader"
            action=""
            drag
            :data="param"
            :http-request="httpRequestImage"
            :show-file-list="false"
            :on-success="uploadImageSuccess"
            :before-upload="beforeAvatarUploadIcon"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">
            只能上传png/jpg文件，且不超过2M
          </div>
        </el-upload>
      </el-dialog>
    </div>
    <el-dialog
        title="二维码下载"
        :visible.sync="QrCodeVisible"
        top="30vh"
        style="margin-left: 40vw"
        class="dialogClass"
        width="350px">
        <div>
            <el-image
                style="width: 200px; height: 200px;display:block;margin: 0 auto"
                :lazy="true"
                :src="this.qrCodeUrl" />
            <el-button type="text" style="display:block;margin: 0 auto" @click="downloadQrCode">下载二维码</el-button>
        </div>
        <span slot="footer" class="dialog-footer">
        <el-button @click="QrCodeVisible = false">关闭</el-button>
        </span>
    </el-dialog>

    <el-dialog
        :visible.sync="cdnDialogVisible"
        width="20%">
      <span style="display: flex;justify-content: space-around">
        <el-button
            v-if="showRefresh"
            type="text"
            size="small"
            :class="{'btn-gap': !showSubpackage}"
            @click="refreshTask()">
        刷新APK
      </el-button>
      <el-button
          v-if="showRefresh"
          type="text"
          size="small"
          :class="{'btn-gap': !showSubpackage}"
          @click="refreshTask2()">
        刷新图标
      </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  queryGameList,
  submitGameIco,
  upload,
  uploadIMG,
  getPageButtons,
  pushGame,
  updateAdminAutoShare,
  forcePackage,
  gameOfChannelDropDown,
  createQrCode,
  uploadPackage,
  uploadImage,
  oneKeySubpackage,
  createRefreshTask,
  getProgress,
  refreshApp,
  refreshIcon,
  gameChannelDropDown
} from "@/api/request";

export default {
  name: "gameList",
  props: {
    pictureUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isSupper: false,
      isShowGameOf: false,
      imgSuffix: "",
      imageUrl: "",
      dialogFormVisible: false,
      dialogFormVisible1: false,
      QrCodeVisible: false,
      tableData: [],
      param: {
        gameId: "",
        progress: "",
        channel:  "",
      },

      manufacturers: "",
      restaurants: [],

      loadProgress: 0,
      queryField: {
        gameId: "",
        gameName: "",
        gameOf: "",
        gameStatus: "",
        gameType: "",
        gameTopic: "",
        gameGrade: "",
        queryType: "",
        showForum: "",
        indexType: "0",
      },
      optionsGameStatus: [
        {
          value: "",
          label: "游戏状态",
        },
        {
          value: "1",
          label: "调试",
        },
        {
          value: "2",
          label: "上线",
        },
        {
          value: "3",
          label: "下线",
        },
      ],
      optionsGameGrade: [
        {
          value: "",
          label: "游戏级别",
        },
        {
          value: "1",
          label: "S级",
        },
        {
          value: "2",
          label: "A级",
        },
        {
          value: "3",
          label: "B级",
        },
        {
          value: "4",
          label: "C级",
        },
      ],
      optionsGameTopic: [
        {
          value: "",
          label: "游戏类别",
        },
        {
          value: "1",
          label: "卡牌",
        },
        {
          value: "2",
          label: "传奇",
        },
        {
          value: "3",
          label: "武侠",
        },
        {
          value: "4",
          label: "角色",
        },
        {
          value: "5",
          label: "养成",
        },
        {
          value: "6",
          label: "三国",
        },
        {
          value: "7",
          label: "奇迹",
        },
        {
          value: "8",
          label: "BT",
        },
        {
          value: "9",
          label: "休闲",
        },
        {
          value: "10",
          label: "放置",
        },
      ],
      optionsGameType: [
        {
          value: "",
          label: "游戏类型",
        },
        {
          value: "1",
          label: "H5",
        },
        {
          value: "2",
          label: "手游",
        },
        {
          value: "3",
          label: "CPS",
        },
      ],
      total: 0,
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      height: window.innerHeight - 250,
      showQuery: false,
      showAdd: false,
      showDetail: false,
      showEdit: false,
      showPackage: false,
      showDownload: false,
      showPush: false,
      showAuto: false,
      showQrCode: false,
      showSubpackage: false,
      showRefresh: false,
      currentIndex: Number(sessionStorage.getItem("gameCurrentIndex")),
      groupId: '',
      qrCodeUrl: '', // 二维码url
      cdnDialogVisible: false,
      refreshGameId: "",
      showCpsProgress: false,
      channelList: [],
      cpsDialogFormVisible: false,
    };
  },
  mounted() {
    let user = JSON.parse(localStorage.getItem("userInfo"));
    this.isSupper = user.groupId === "1";
    this.isShowGameOf = user.groupId === "1" || user.groupId === "22";
    this.groupId = user.groupId;
    this.upGameList();
    this.loadAll();
    this.loadData(this.currentIndex);
    this.getPageButtons();
  },
  methods: {
    upGameList() {
      if (sessionStorage.getItem("gamelistStor") != null) {
        let params = JSON.parse(sessionStorage.getItem("gamelistStor"));
        (this.queryField.gameId = params.game_id),
          (this.queryField.gameName = params.game_name),
          (this.queryField.gameOf = params.game_of),
          (this.queryField.gameType = params.game_type),
          (this.queryField.gameTopic = params.game_topic),
          (this.queryField.gameStatus = params.game_status),
          (this.queryField.queryType = params.query_type),
          (this.queryField.gameGrade = params.game_grade);
      }
    },
    moveSission() {
      sessionStorage.removeItem("gamelistStor");
      this.$router.go(0);
    },
    save(row) {
      const reg = /^[01]([.][0-9]{0,4})?$/;
      if (!reg.test(row.auto_share + "")) {
        this.$message.error("自助提成格式不正确");
        return;
      }

      if (row.auto_share < 0 || row.auto_share > 1) {
        this.$message.error("提成比例应设置在0~1.0之间");
        return;
      }
      let params = {
        game_id: row.game_id,
        auto_share: row.auto_share,
      };
      updateAdminAutoShare(params).then((res) => {
        if (res.data.success) {
          this.$message.success("自助提成配置成功");
        } else {
          this.$message.error(res.data.error.message);
        }
      });
    },
    getPageButtons() {
      let path = this.$route.path.replace("/", "");
      getPageButtons(path).then((res) => {
        if (res.data.success) {
          let menuCodes = res.data.data;
          //let menuCodes = [];
          this.showQuery = menuCodes.includes("game_list_query");
          this.showAdd = menuCodes.includes("game_list_add");
          this.showDetail = menuCodes.includes("game_list_detail");
          this.showEdit = menuCodes.includes("game_list_edit");
          this.showPackage = menuCodes.includes("game_list_package");
          this.showDownload = menuCodes.includes("game_list_download");
          this.showPush = menuCodes.includes("game_list_push");
          this.showAuto = menuCodes.includes("game_list_save");
          this.showQrCode = menuCodes.includes("game_qr_code_save");
          this.showSubpackage = menuCodes.includes("game_one_key_subpackage");
          this.showRefresh = menuCodes.includes("game_refresh_cdn");
        } else {
          this.$message.error(res.data.error.message);
        }
      });
    },
    loadData(index) {
      let params = {
        pageNo: index,
        pageSize: 15,
        params: {
          game_id: this.queryField.gameId,
          game_name: this.queryField.gameName,
          game_of: this.queryField.gameOf,
          game_type: this.queryField.gameType,
          game_topic: this.queryField.gameTopic,
          game_status: this.queryField.gameStatus,
          query_type: this.queryField.queryType,
          game_grade: this.queryField.gameGrade,
          show_forum: this.queryField.showForum,
          index_type: this.queryField.indexType,
        },
      };
      //自动矫正错误页数
      let str = '^[0-9]*$';
      if(!str.search(index) || index === 0){
        params.pageNo = 1;
      }
      sessionStorage.setItem("gameCurrentIndex",params.pageNo);
      sessionStorage.setItem("gamelistStor", JSON.stringify(params.params));
      queryGameList(params).then((res) => {
        this.tableData = res.data.list;
        this.total = res.data.total;
        this.currentIndex = index;
        
        //解决固定列错位问题
        this.$nextTick(() => {
          this.$refs.tableRef.doLayout();
        })
      });
    },
    detail(row) {
      console.log(row);
    },
    doSubpackage(gameId,gameName){
      this.$confirm("确认要对" + gameName + "一键分包吗","提示",{
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        oneKeySubpackage(gameId).then(res => {
          if(res.data.success){
            this.$message.success("操作成功")
          }else {
            this.$message.error(res.data.error.message)
          }
        });
      })
    },
    refreshTask(){
      this.$confirm("确认要刷新APK吗","提示",{
        confirmButtonText: "刷新",
        cancelButtonText: "取消",
        type: "info"
      }).then(() => {
        refreshApp(this.refreshGameId).then(res => {
          if(res.data.success){
            this.$message.success("操作成功,5~10分钟后生效")
          }else {
            this.$message.error(res.data.error.message)
          }
        })
      })
    },
    refreshTask2(){
      this.$confirm("确认要刷新图标吗","提示",{
        confirmButtonText: "刷新",
        cancelButtonText: "取消",
        type: "info"
      }).then(() => {
        refreshIcon(this.refreshGameId).then(res => {
          if(res.data.success){
            this.$message.success("操作成功，5~10分钟后生效")
          }else {
            this.$message.error(res.data.error.message)
          }
        })
      })
    },
    toAdd() {
      this.$router.replace("/gameList/gameAdd");
    },
    toEdit(gameId) {
      this.$router.replace(`/gameList/gameEdit/${gameId}`);
    },
    toUpload(row) {
      if(row.game_type !== 3) {
        this.dialogFormVisible = true;
      }else {
        this.queryChannel();
        this.cpsDialogFormVisible = true;
      }
      this.param.gameId = row.game_id;
      this.$nextTick(function () {
        this.param.progress = this.$refs["appLoadProgress"];
      });
    },
    toUploadIMG(gameId) {
      this.dialogFormVisible1 = true;
      this.param.gameId = gameId;
      this.$nextTick(function () {
        this.param.progress = this.$refs["iconLoadProgress"];
      });
    },
    toPush(gameId,auditFlag) {
      pushGame(gameId).then((res) => {
        if (res.data.success) {
            if(this.groupId != 1 && auditFlag == 2 && res.data.data != null){
                return this.$message.success(res.data.data)
            }
            this.$message.success("操作成功，正在给你分包，一般15至30分钟，推广链接提示未成功分包请联系管理员");
        } else {
          this.$message.error(res.data.error.message);
        }
      });
    },
    forcePackage(gameId) {
      this.$confirm("此操作将删除这个游戏的所有oss数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          forcePackage(gameId).then((res) => {
            if (res.data.success) {
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.data.error.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消强制分包",
          });
        });
    },
    toCreateQrCode(gameId){
        createQrCode(gameId).then(res => {
            if(res.data.success){
                this.qrCodeUrl = res.data.data;
                this.QrCodeVisible = true;
            }else {
                this.$message.error(res.data.error.message);
            }
        })
    },
    downloadQrCode(){
        const a = document.createElement('a');
        a.href = this.qrCodeUrl;
        a.setAttribute('download', new Date().getTime().toString());
        a.click();
    },
    formatGameType(row, column, cellValue) {
      let ret = "";
      if (cellValue === 1) {
        ret = "H5";
      } else if(cellValue === 2){
        ret = "手游";
      }else if(cellValue === 3) {
        ret = "CPS"
      }
      return ret;
    },
    formatGameSystem(row, column, cellValue) {
      let ret = "";
      if (cellValue === 1) {
        ret = "安卓";
      }else if (cellValue === 2){
        ret = "IOS";
      } else{
        ret = "全部";
      }
      return ret;
    },

    formatGameStatus(row, column, cellValue) {
      let ret = "";
      if (cellValue === 1) {
        ret = "调试";
      } else if (cellValue === 2) {
        ret = "上线";
      } else {
        ret = "下线";
      }
      return ret;
    },
    formatGameGrade(row, column, cellValue) {
      let ret = "";
      if (cellValue === 1) {
        ret = "S级";
      } else if (cellValue === 2) {
        ret = "A级";
      } else if (cellValue === 3) {
        ret = "B级";
      } else {
        ret = "C级";
      }
      return ret;
    },
    // 上传文件之前的钩子
    beforeAvatarUpload(file) {
      let filename = file.name;
      let pos = filename.lastIndexOf(".");
      let suffix = "";
      if (pos != -1) suffix = filename.substring(pos);
      let isApp = ".ipa" === suffix || ".apk" === suffix;
      const isLt5G = file.size / 1024 / 1024 / 1024 < 5;
      if (!isApp) {
        this.$message.error("上传文件只能是 ipa或者apk 格式!");
      }
      if (!isLt5G) {
        this.$message.error("上传文件大小不能超过 5GB!");
      }
      return isApp && isLt5G;
    },
    beforeAvatarUploadIcon(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!(isJPG || isPNG)) {
        this.$message.error("上传头像图片只能是JPG或者PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      let filename = file.name;
      let pos = filename.lastIndexOf(".");
      let suffix = "";
      if (pos != -1) suffix = filename.substring(pos);
      this.imgSuffix = suffix;
      return (isJPG || isPNG) && isLt2M;
    },
    handleAvatarSuccess(file) {
      this.$message.success("文件上传成功");
      this.dialogFormVisible = false;
      this.loadProgress = 0;
    },
    handleAvatarSuccessIMG(file) {
      let param = {
        game_icon: this.imgSuffix,
        game_id: this.param.gameId,
      };
      submitGameIco(param).then((res) => {
        if (res.data.success) {
          this.$message.success("logo上传成功");
          this.dialogFormVisible1 = false;
        } else {
          this.$message.error(res.data.error.message);
        }
      });
    },
    // 覆盖elemen的上传函数
    async httpRequest(item) {
      let result = await upload(item);
    },

    async httpRequest2(item){
      await uploadPackage(item,this.uploadProgress).then(res => {
        if(res.success){
          if(!this.param.channel) {
            this.dialogFormVisible = false;
          }else {
            this.cpsDialogFormVisible = false;
          }
          this.$message({
            type: "success",
            message: "上传成功"
          })
        }else {
          this.$message.error(res.data.error.message);
        }
      }).finally(() => {
        this.loadProgress = 0;
        this.param.channel = "";
        this.showCpsProgress = false;
        this.$refs["cps-upload"].clearFiles();
      });
    },
    uploadProgress(e){
      let progress = parseInt((e.loaded / e.total) * 100);
      this.loadProgress = progress;
    },
    
    async httpRequestIMG(item) {
      let result = await uploadIMG(item);
    },

    querySearch(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        //return restaurant.nickName.indexOf(queryString.toLowerCase()) === 0;
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      };
    },
    handleSelect(item) {
      this.queryField.game_of = item.value;
      if (item.value === "") {
        this.loadAll("");
      } else {
        this.loadAll(item.value);
      }
    },
    loadAll() {
      let me = this;
      gameOfChannelDropDown().then((res) => {
        me.restaurants = [];
        res.data.data.forEach(function (e) {
          let item = {};
          item.value = e.game_of;
          me.restaurants.push(item);
        });
      });
    },
    uploadImageSuccess(response, file, fileList){
      this.dialogFormVisible1 = false;
      this.$message({
        type: "success",
        message: "logo上传成功"
      })
    },
    async httpRequestImage(item){
      const res = await uploadImage(item);
    },
    queryChannel() {
      gameChannelDropDown().then(res => {
        if(res.data.success) {
          this.channelList = [...res.data.data]
        }else {
          this.$message.error("系统繁忙，请稍后再试！");
        }
      })
    },
    submitCpsUpload() {
      if(!this.param.channel) {
        this.$message.warning("请选择渠道");
        return;
      }
      let files = this.$refs["cps-upload"].uploadFiles;
      if(files.length <= 0) {
        this.$message.warning("请先上传文件");
        return;
      }
      this.showCpsProgress = true;
      this.$refs["cps-upload"].submit();
    },
    cancelCpsUpload() {
      this.cpsDialogFormVisible = false
      this.showCpsProgress = false;
      this.$refs["cps-upload"].clearFiles();
    },
  },
};
</script>
<style lang="scss" scoped>
.cps-main-page {
  .cps-table-data {
    td {
      .el-image {
        display: inherit;
      }
    }
  }
}
.upload__tip {
    font-size: 12px;
    color: #606266;
    margin-top: 0;
}
.cps-upload-dialog {
}
.cps-upload-dialog .el-form /deep/ .el-form-item {
    margin-bottom: 10px;
}
</style>
<style>
.dialogClass .el-dialog__body{
    padding-bottom: 10px;
}

.btn-gap{
  margin-left: 0 !important;
}

.input-view{
  
  
}

.cps-upload-dialog .el-dialog__header {
    border-bottom: 1px solid #dcdfe6;
    padding: 15px 20px;
}
.cps-upload-dialog .el-dialog__footer {
    border-top: 1px solid #dcdfe6;
    padding: 15px 20px;
}
</style>

